exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".sw-table-pagination.sw-simple-link-pagination{display:flex;flex-direction:row;justify-content:flex-end;align-items:center;padding-right:5px}.sw-table-pagination.sw-simple-link-pagination .sw-table-pagination-link{font-size:12px;line-height:12px}\n", ""]);
